// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"265ea410","769":"164d6e3d"}[chunkId] + ".chunk.css";
};